export const DEFAULT_PRICE_POLICY = { minMarginPct: 15, roundingEndingCents: 90 };
function roundToEnding(priceCents, endingCents) {
    const whole = Math.floor(priceCents / 100) * 100;
    const rounded = whole + endingCents;
    return rounded >= priceCents ? rounded : rounded + 100;
}
function marginPctFor(priceCents, costCents) {
    if (priceCents <= 0)
        return -Infinity;
    return ((priceCents - costCents) / priceCents) * 100;
}
/**
 * Recomenda um preço a partir do custo e da margem alvo, nunca abaixo do piso
 * de margem aprovado (`policy.minMarginPct`) mesmo que isso signifique
 * ignorar o preço do concorrente. Quando há preços de concorrência, usa a
 * mediana como referência de mercado, mas o piso de margem sempre vence.
 */
export function computeRecommendedPrice({ costCents, marginTargetPct, competitorPricesCents = [], policy = DEFAULT_PRICE_POLICY }) {
    if (!Number.isFinite(costCents) || costCents <= 0)
        throw new Error("costCents must be a positive number");
    const floorPriceCents = Math.ceil(costCents / (1 - policy.minMarginPct / 100));
    const targetPriceCents = Math.ceil(costCents / (1 - marginTargetPct / 100));
    let basePriceCents = targetPriceCents;
    let rationale = `Preço calculado para atingir margem alvo de ${marginTargetPct}% sobre o custo.`;
    let belowFloor = false;
    if (competitorPricesCents.length > 0) {
        const sorted = [...competitorPricesCents].sort((a, b) => a - b);
        const median = sorted.length % 2 === 0
            ? Math.round((sorted[sorted.length / 2 - 1] + sorted[sorted.length / 2]) / 2)
            : sorted[(sorted.length - 1) / 2];
        if (median > targetPriceCents) {
            basePriceCents = targetPriceCents;
            rationale = `Mediana da concorrência (${median} centavos) está acima do preço de margem alvo; mantido o preço de margem alvo.`;
        }
        else if (median >= floorPriceCents) {
            basePriceCents = median;
            rationale = `Ajustado para a mediana da concorrência (${median} centavos), ainda acima do piso de margem aprovado.`;
        }
        else {
            basePriceCents = floorPriceCents;
            belowFloor = true;
            rationale = `Mediana da concorrência (${median} centavos) ficaria abaixo do piso de margem aprovado (${policy.minMarginPct}%); mantido o piso.`;
        }
    }
    const recommendedPriceCents = roundToEnding(basePriceCents, policy.roundingEndingCents);
    return {
        recommendedPriceCents,
        marginPct: Math.round(marginPctFor(recommendedPriceCents, costCents) * 100) / 100,
        rationale,
        belowFloor
    };
}
/** Bucket determinístico para experimentação simples (A/B), sem depender de
 * estado — o mesmo customerId sempre cai na mesma variante para um dado
 * experimento. */
export function assignExperimentVariant(experimentId, customerId, variants = ["control", "variant"]) {
    const key = `${experimentId}:${customerId}`;
    let hash = 0;
    for (let index = 0; index < key.length; index += 1)
        hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
    return variants[hash % variants.length];
}
